module.exports = __webpack_public_path__ + "img/title2-en.f29be918.png";